var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{ 'loader--visible': _vm.visible }},[_c('img',{attrs:{"src":require("@/assets/images/loading.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }